<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" @chooseCustomerChange="chooseCustomerChange" />
      <GoodsForm ref="goodsForm" />
      <LineForm ref="lineForm" @getUnSelectDistrict="getUnSelectDistrict" />
      <IncomeForm
        ref="incomeForm"
        @copyValueToOutwardCar="copyValueToOutwardCar"
      />
      <CostForm ref="costForm" />
      <OutwardcarForm ref="outwardcarForm" />
      <SettlementForm ref="settlementForm" />
      <OtherForm ref="otherForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import GoodsForm from './goods';
import LineForm from './line';
import IncomeForm from './income';
import CostForm from './cost';
import OutwardcarForm from './outwardcar';
import SettlementForm from './settlement';
import OtherForm from './other';
import SubBtnBox from 'components/subBtnBox';
import {
  cityCustomerSaveOrUpdate,
  cityCustomerLineQueryByLineId,
} from 'api/distribution';
import {
  queryAddressInfo,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    GoodsForm,
    LineForm,
    IncomeForm,
    CostForm,
    OutwardcarForm,
    SettlementForm,
    OtherForm,

    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/distribution/customerLine/edit',
      formComponents: [
        'baseForm',
        'goodsForm',
        'lineForm',
        'incomeForm',
        'costForm',
        'outwardcarForm',
        'settlementForm',
        'otherForm',
      ],

      // 需要对比的参数
      compareParams: {
        customerId: '',
        lineName: '',
        lineTel: '',
        orgId: '',
        effectBegin: '',
        effectEnd: '',
        customerLineNo: '',

        vehicleLength: '',
        vehicleStatus: '',
        goodsWeight: '',
        goodsVolume: '',
        goodsType: '',
        goodsName: '',
        tempType: '',
        tempStart: '',
        tempEnd: '',

        sourceEand: '',
        sourceNand: '',
        lineCodeName: '',
        subLinaAreaStr: [],

        incomeChargeMode: '',
        incomeBasic: '',
        incomeBasicCount: '',
        incomeRegionalCost: '',
        incomeMileageBasic: '',
        incomeMileageSinglekm: '',

        oilCostPer: '',
        pontagePer: '',
        emptyOilCostPer: '',

        costChargeMode: '',
        costBasic: '',
        costBasicCount: '',
        costRegionalCost: '',
        costMileageBasic: '',
        costMileageSinglekm: '',

        payWay: '',
        reciveTime: '',
        reciveTimeDay: '',
        collectionTime: '',
        collectionTimeDay: '',

        remarks: '',
      },
    };
  },
  computed: {
    editParams () {
      let params = {};
      if (this.$route.query.id) {
        params.lineId = this.$route.query.id;
      }
      return params;
    },
    detailParams () {
      return {
        lineId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: cityCustomerLineQueryByLineId,
    editApi: cityCustomerSaveOrUpdate,

    // 处理对比参数
    adjustCompareParams (compareParams) {
      compareParams.effectBegin = this.formatDate(compareParams.effectBegin);
      compareParams.effectEnd = this.formatDate(compareParams.effectEnd);
      compareParams.subLinaAreaStr = '[]';
    },

    handleParams (params) {
      let subLinaArea = [];
      subLinaArea = [
        // 配送区县
        ...JSON.parse(params.subLineAreaBaseList || '[]'),
        // 收入信息 - 超区区县
        ...JSON.parse(params.crossDistrictIncomeList || '[]'),
        // 外调信息 - 超区区县
        ...JSON.parse(params.crossDistrictCostList || '[]'),
      ];
      // 新增的项
      let addList = [];
      // 修改的项
      let editList = [];
      // 删除的项
      let deleteList = [];
      // 之前的提交的数据
      const subLinaAreaBackUp = typeof params.subLinaAreaBackUp === 'string' ? JSON.parse(params.subLinaAreaBackUp) : [];

      if (subLinaAreaBackUp.length) {
        // 修改的时候，有线路详情的备份数据
        // 设置 operType 操作类型：1.新增 2.修改 3.删除
        for (let itemPre of subLinaAreaBackUp) {
          for (let itemCur of subLinaArea) {
            if (itemCur.cclaId) {
              if (itemPre.cclaId === itemCur.cclaId) {
                // 如果修改过，标识符设置为 修改
                if (
                  itemPre.desCounty !== itemCur.desCounty || itemPre.desCity !== itemCur.desCity || itemPre
                    .desProvince !== itemCur.desProvince ||
                  itemCur.superzoneFee &&
                  Number(itemPre.superzoneFee) !== Number(itemCur.superzoneFee)
                ) {
                  itemPre.operType = 2;
                }
              }
            } else {
              // 没有 cclaId 的就是新增的
              itemCur.operType = 1;
            }
          }
        }
      } else {
        // 新增的时候没有备份数据
        for (let item of subLinaArea) {
          if (!item.cclaId) {
            item.operType = 1;
          }
        }
      }

      addList = subLinaArea.filter((item) => item.operType === 1);
      editList = subLinaArea.filter((item) => item.operType === 2);

      // 找出删除的项
      deleteList = subLinaAreaBackUp.filter((item) => !subLinaArea.some((ele) => ele.cclaId === item.cclaId));
      deleteList.map((item) => {
        item.operType = 3;
      });

      const subLinaAreaStrList = [
        ...addList,
        ...editList,
        ...deleteList,
      ];

      if (subLinaAreaStrList && subLinaAreaStrList.length) {
        params.subLinaAreaStr = JSON.stringify(subLinaAreaStrList);
      } else {
        params.subLinaAreaStr = '[]';
      }

      // delete params.subLineAreaBaseList;
      // delete params.crossDistrictIncomeList;
      // delete params.crossDistrictCostList;
    },
    chooseCustomerChange (data) {
      if (this.$refs.lineForm && this.$refs.lineForm.chooseCustomerChange) {
        this.$refs.lineForm.chooseCustomerChange(data);
      }
    },
    getUnSelectDistrict (data) {
      for (let item of this.formComponents) {
        if (this.$refs[item] && this.$refs[item].setUnSelectDistrict) {
          this.$refs[item].setUnSelectDistrict(data);
        }
      }
    },
    // 把收入信息中的内容复制到成本信息中
    copyValueToOutwardCar (data) {
      for (let item of this.formComponents) {
        if (this.$refs[item] && this.$refs[item].copyValueToOutwardCar) {
          this.$refs[item].copyValueToOutwardCar(data);
        }
      }
    },
  },
  async mounted () {
    this.getData();

    const addressList = await queryAddressInfo();
    if (this.$refs.lineForm) {
      this.$refs.lineForm.setAddressInfo(addressList);
    }
    if (this.$refs.incomeForm) {
      this.$refs.incomeForm.setAddressInfo(addressList);
    }
    if (this.$refs.outwardcarForm) {
      this.$refs.outwardcarForm.setAddressInfo(addressList);
    }
  },
};
</script>

<style scoped lang="scss">
</style>
